module.exports = __webpack_public_path__ + "img/versus.3e3a3371.svg";